import moment from 'moment';

export const startOfWeek = (): any => moment().startOf('week');

export const formatShortDate = (time: number): string => moment(time * 1000).format('MM/DD/YYYY');

export const formatShortDateTime = (time: number): string => moment(time * 1000).format('MM/DD/YYYY h:mm a');

export const isSameDay = (date1: number, date2: number): any => moment(date1 * 1000).isSame(date2 * 1000, 'day');
